var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('span',{staticClass:"info"},[_vm._v("If you have any question please write to "),_c('a',{attrs:{"target":"_blank","href":"mailto:info@missionmag.org"}},[_vm._v("info@missionmag.org")])])])
}]

export { render, staticRenderFns }